export default "__VITE_ASSET__8be034e6__"